import { Clock, ShieldCheck, Trash2 } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

/**
 * Three short, literally-true claims about the feature — same rhetorical shape as the
 * Hero's `CLAIMS` panel, applied to one feature instead of the whole app.
 */
const BABYSITTER_CLAIMS = [
  {
    icon: Clock,
    title: 'A window, not a standing invite',
    body: 'Pick an exact start and end time when you invite a babysitter. Sync only runs inside that window — nothing moves before it opens or after it closes.',
  },
  {
    icon: ShieldCheck,
    title: 'Full access while it lasts',
    body: 'During the window, a babysitter can log feeds, diapers, sleep, and everything else — same as a co-parent, just temporary.',
  },
  {
    icon: Trash2,
    title: 'Gone when the shift ends',
    body: "When the window closes, their phone clears its copy of your child's log on its own. Nothing lingers on a device you don't control.",
  },
] as const;

export function BabysitterMode() {
  return (
    <section id="babysitter" className="container scroll-mt-24 py-20 sm:py-28">
      <div className="max-w-lg">
        <p className="kicker">For date nights and everything else</p>
        <h2 className="mt-3 text-[clamp(2rem,4.5vw,3rem)] leading-[1.05]">Babysitter mode</h2>
        <p className="mt-4 text-muted-foreground">
          Give a babysitter a time-boxed view into your child's log — no standing pairing to
          remember to revoke, no data left behind after they head home.
        </p>
      </div>

      <div className="mt-12 grid gap-6 sm:grid-cols-3">
        {BABYSITTER_CLAIMS.map(({ icon: Icon, title, body }) => (
          <Card key={title} className="bg-card/60">
            <CardHeader>
              <Icon aria-hidden="true" className="size-6 text-berry" />
              <CardTitle className="mt-3 font-display text-lg">{title}</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-[0.95rem] leading-relaxed">{body}</CardDescription>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
